import { Result } from 'src_common/common/mobx-utils/Form2/FormModel';

export const validateIsNumber = (value: string): Result<string> => {
    const number = parseInt(value, 10);
    if (value === '') {
        return Result.createOk('');
    }

    if (isNaN(number)) {
        return Result.createError('Invalid number');
    }

    if (number.toString() !== value.trim()) {
        return Result.createError('Invalid number');
    }

    return Result.createOk(value);
};
